export default "__VITE_ASSET__DvIR92sh__"